/* global axios */
import ApiClient from './ApiClient';

class CampaignTemplatesAPI extends ApiClient {
  constructor() {
    super('campaign_templates', { accountScoped: true });
  }

  preview(templateData, contactId) {
    return axios.post(`${this.url}/preview`, {
      campaign_template: templateData,
      contact_id: contactId,
    });
  }
}

export default new CampaignTemplatesAPI();
